import "proxy-polyfill/proxy.min"; // Polyfill the window.Proxy object when not already supported
import PubSub from './pub_sub.js';
import {MixinPersistentStore} from "./mixins/persistable";

export default class StateMachine {

    constructor(params) {
        let self = this;
        self.id = null;
        self.name = 'Unnamed';
        self.actions = {};
        self.mutations = {};
        self.state = {};
        self.status = 'resting';
        self.events = new PubSub();
        self.persistentStore = null;

        if(params.hasOwnProperty('id')) {
            self.id = params.id;
        }

        if(params.hasOwnProperty('name')) {
            self.name = params.name;
        }

        if(params.hasOwnProperty('actions')) {
            self.actions = params.actions;
        }

        if(params.hasOwnProperty('mutations')) {
            self.mutations = params.mutations;
        }

        self.state = new Proxy((params.state || {}), {
            set: function(state, key, value) {

                state[key] = value;

                console.log(`[${ self.name }] SM Change: ${key}:`, value);

                if (self.persist && self.persist[key] === true) {
                    console.log(`[${ self.name }] SM Persist: ${key}:`, value);
                    self.setStoreItem(key, value);
                }

                self.events.publish('stateChange', self.state);

                if(self.status !== 'mutation') {
                    console.warn(`${ self.name } SM: You should use a mutation to set ${key}`);
                }

                return true;
            }
        });

        if (params.hasOwnProperty('persist')) self.persist = params.persist;
        MixinPersistentStore(self); // Add the persistent storage management methods to `self`.
        if (params.hasOwnProperty('persistentStore')) self.setPersistentStore(params.persistentStore);
        if (params.hasOwnProperty('persistentStorageKey')) self.setPersistentStorageKey(params.persistentStorageKey);
    }

    /**
     * Returns a copy of the current state object.
     *
     * @returns {Object} A copy of the current state.
     */
    getState() {
        // Clone the underlying data, not the Proxy itself
        const rawState = {};
        for (const key in this.state) {
            rawState[key] = this.state[key];
        }

        // Use structuredClone if available, otherwise fall back to JSON.parse(JSON.stringify())
        if (typeof structuredClone === 'function') {
            return structuredClone(rawState);
        } else {
            return JSON.parse(JSON.stringify(rawState));
        }
    }


    dispatch(actionKey, payload) {

        let self = this;

        if(typeof self.actions[actionKey] !== 'function') {
            console.error(`[${ self.name }] SM Action "${actionKey}" doesn't exist.`);
            return false;
        }

        console.groupCollapsed(`[${ self.name }] SM Action: ${actionKey}`);

        self.status = 'action';

        self.actions[actionKey](self, payload);

        console.groupEnd();

        return true;
    }

    commit(mutationKey, payload) {
        let self = this;

        if(typeof self.mutations[mutationKey] !== 'function') {
            console.error(`[${ self.name }] SM Mutation "${mutationKey}" doesn't exist`);
            return false;
        }

        self.status = 'mutation';

        let newState = self.mutations[mutationKey](self.state, payload);

        self.status = 'resting';

        return true;
    }

    touch() {
        console.groupCollapsed(`[${ this.name }] SM Touch`);
        this.events.publish('stateChange', this.state);
        console.groupEnd();
        return true;
    }

}